import { createListenerMiddleware } from '@reduxjs/toolkit';

import { PopupType } from '../../../components/popup/types';
import { fetchPlayerConfigAction } from '../../apiActions/fetchPlayerConfigAction';
import type { CoreRootState } from '../../CoreStore';

import { popupActions } from './slice';

export const popupMiddleware = createListenerMiddleware<CoreRootState>();

// Listener to show the nickname enter popup when the screen name is not set
const cancelNicknamePopupListener = popupMiddleware.startListening({
  actionCreator: fetchPlayerConfigAction.fulfilled,
  effect: (action, { dispatch }) => {
    const screenName = action.payload.rawResponse.screenName;
    if (!screenName || screenName === 'null') {
      dispatch(popupActions.pushPopup(PopupType.NicknameEnter));
    }
    cancelNicknamePopupListener();
  },
});
